const sizeAbbreviationOrder = [
  'xxxs',
  'tttp',
  'xxs',
  'ttp',
  'xs',
  'tp',
  's',
  'p',
  'm',
  'g',
  'l',
  'xl',
  'tg',
  'xxl',
  'ttg',
  'xxxl',
  'tttg',
  'xxxxl',
  'ttttg',
];

export const sizeAbbreviationOrderMap = new Map(
  sizeAbbreviationOrder.map((size, index) => [size, index])
);

export const braCupSizes = [
  'AA',
  'A',
  'AB',
  'B',
  'BC',
  'C',
  'CD',
  'D',
  'DD',
  'E',
  'F',
  'G',
  'H',
];

export const braCupSizeOrderMap = new Map(
  braCupSizes.map((size, index) => [size, index])
);

export const childSizes = [
  'Baby (0-2 yrs)',
  'Bébé (0-2 ans)',
  'Toddler and Child (2-7 yrs)',
  'Tout-petits et enfants (2-7 ans)',
  'Youth (8-16 yrs)',
  'Jeunes (8-16 ans)',
  'Alpha',
];

// These are the bucket names we are using right now, and we want them to appear in this order (if they are present)
// If we have bucket names besides these, they will work, but they will appear at the end of the list
const namePriorityList = [
  'Clothing Size',
  'Taille des vêtements',
  'Waist',
  'Tour de taille',
  'US',
  'Bottoms',
  'Bra Size',
  'Taille de soutien-gorge',
  'Hats',
];

export const sizeOrder = new Map(
  [...childSizes, ...namePriorityList].map((size, index) => [size, index])
);
